// extracted by mini-css-extract-plugin
export var content = "product-content-module--content---CWHe";
export var eanBox = "product-content-module--ean-box--DC+jw";
export var familyBox = "product-content-module--family-box--6+dp7";
export var imgBox = "product-content-module--img-box--YFzrc";
export var infoBox = "product-content-module--info-box---iDee";
export var linkButton = "product-content-module--linkButton--Hp1Fo";
export var shortDescriptionBox = "product-content-module--short-description-box--r1uGU";
export var subtitle = "product-content-module--subtitle--uIOfz";
export var title = "product-content-module--title--rl02v";